import { inject, Pipe, type PipeTransform } from '@angular/core';
import { UserDataService } from 'src/app/services/user-data/user-data.service';

@Pipe({
	name: 'userPermission',
})
export class UserPermissionPipe implements PipeTransform {
	private userDataService = inject(UserDataService);

	/**
	 * Checks if the user has the specified role.
	 *
	 * @param role - The role to check.
	 * @returns A boolean indicating whether the user has the specified role.
	 */
	transform(role: string): boolean {
		return this.userDataService.doesUserHaveRole(role);
	}
}
